import type { TallyThreshold } from './pestConfig';

export type Flag = 'exceeded' | 'approaching' | 'below';

export const examinedCount = (maxExamined: number): number => maxExamined + 1;

export function pct(infestedPoints: number, examined: number): number {
  if (examined <= 0) return 0;
  return Math.round((infestedPoints / examined) * 100);
}

export function flagFor(value: number, actionThreshold: number): Flag {
  if (actionThreshold > 0 && value >= actionThreshold) return 'exceeded';
  if (actionThreshold > 0 && value / actionThreshold >= 0.8) return 'approaching';
  return 'below';
}

export function dotState(pointId: number, ctx: { infested: Set<number>; maxExamined: number }): 'red' | 'green' | 'grey' {
  if (pointId > ctx.maxExamined) return 'grey';
  return ctx.infested.has(pointId) ? 'red' : 'green';
}

export function tallyThresholdInForce(pest: { tallyThreshold?: TallyThreshold }): TallyThreshold {
  return pest.tallyThreshold ?? 'any';
}
